import { AppState, Auth0Provider } from '@auth0/auth0-react'
import { Messages, i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import {
  navigate,
  WrapPageElementBrowserArgs,
  WrapRootElementBrowserArgs,
} from 'gatsby'
import React, { useLayoutEffect, useState } from 'react'

import publicConfig from './src/logic/public-config'

import './src/assets/styles/_reset.scss'
import './src/assets/styles/_font.scss'
import './src/assets/styles/_globals.scss'
import './src/assets/styles/_heading.scss'
import './src/assets/styles/_inputField.scss'
import './src/assets/styles/_mixins.scss'
import './src/assets/styles/_richText.scss'
import './src/assets/styles/_tag.scss'
import './src/assets/styles/_skeleton.scss'
import './src/assets/styles/tailwind.css'

const onRedirectCallback = (appState?: AppState) => {
  void navigate(appState?.returnTo || '/', { replace: true })
}

function activateLocale(locale: string) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { messages } = require(
    `@lingui/loader!./src/locale/translations/${locale}.po`,
  ) as { messages: Messages }
  i18n.load(locale, messages)
  i18n.activate(locale)
}

export const wrapRootElement = ({ element }: WrapRootElementBrowserArgs) => {
  return (
    <Auth0Provider
      authorizeTimeoutInSeconds={publicConfig.oidc.authorizeTimeoutInSeconds}
      domain={String(publicConfig.oidc.domain)}
      clientId={String(publicConfig.oidc.clientId)}
      authorizationParams={{
        audience: publicConfig.oidc.audience,
        redirect_uri: `${window.location.origin}/auth/`,
        scope: 'openid profile email',
      }}
      issuer={publicConfig.oidc.issuer}
      onRedirectCallback={onRedirectCallback}
    >
      {element}
    </Auth0Provider>
  )
}

export const wrapPageElement = ({
  element,
  props: {
    pageContext: { locale },
  },
}: WrapPageElementBrowserArgs<Record<string, unknown>, { locale: string }>) => {
  // populate on initial render before I18nProvider is used
  useState(() => activateLocale(locale))
  // ... and reset on locale change
  useLayoutEffect(() => {
    if (i18n.locale !== locale) {
      activateLocale(locale)
    }
  }, [locale])
  return (
    <React.Fragment
      // needs to be remounted on locale change
      key={i18n.locale}
    >
      <I18nProvider i18n={i18n}>{element}</I18nProvider>
      <div id="portal" />
    </React.Fragment>
  )
}
